import { useId, useRef } from "react";
import { Accessibility } from "lucide-react";

import { Switch } from "@/components/ui/switch";
import { useI18n } from "@/i18n/I18nContext";
import { useAccessibility } from "../AccessibilityContext";
import "./login-accessibility-menu.css";

// Shared by the existing member access pages. Preference persistence stays in the provider.
export function LoginAccessibilityMenu() {
  const { t } = useI18n();
  const { a11y, setA11y } = useAccessibility();
  const detailsRef = useRef(null);
  const id = useId();
  const close = () => {
    const details = detailsRef.current;
    if (!details) return;
    details.open = false;
    details.querySelector("summary")?.focus();
  };
  const items = [
    ["high_contrast", t("member.profile.high_contrast")],
    ["large_text", t("member.profile.large_text")],
    ["reduce_motion", t("member.profile.reduce_motion")],
  ];

  return (
    <details ref={detailsRef} className="vl-access-menu" data-testid="login-a11y"
      onKeyDown={(event) => {
        if (event.key === "Escape" && detailsRef.current?.open) {
          event.preventDefault();
          event.stopPropagation();
          close();
        }
      }}>
      <summary data-testid="login-a11y-trigger" aria-controls={`${id}-panel`}>
        <Accessibility size={24} aria-hidden="true" />
        <span>{t("member.profile.accessibility")}</span>
      </summary>
      <div id={`${id}-panel`} role="group" aria-label={t("member.profile.accessibility")}
        data-testid="login-a11y-panel" className="vl-access-menu__panel">
        <p>{t("member.profile.accessibility_note")}</p>
        <div className="vl-access-menu__options">
          {items.map(([key, label]) => (
            <label key={key} htmlFor={`${id}-${key}`}>
              <span>{label}</span>
              <Switch id={`${id}-${key}`} checked={!!a11y[key]}
                onCheckedChange={(value) => setA11y({ [key]: value })}
                className="vl-access-menu__switch"
                data-testid={`login-acc-${key}`} aria-label={label} />
            </label>
          ))}
        </div>
        <button type="button" onClick={close} className="vl-access-menu__close" data-testid="login-a11y-close">
          {t("common.close")}
        </button>
      </div>
    </details>
  );
}
